export const ASSETS_FOLDER_NAME = "assets";
export const EDITOR_FILE_NAME = "editor.json";
export const EXERCISES_FOLDER_ROOT = "exercises";

export function getKeyFromQueryString(location: { search?: string }, prefix?: string) {
  if (!location.search) {
    return prefix ?? "";
  }
  return new URLSearchParams(location.search.substring(1)).get("key") ?? "";
}

export function getS3PrefixFromExerciseKey(s3ExerciseKey: string) {
  const parts = s3ExerciseKey.split("/");
  if (parts.length < 2) return "";
  return parts.slice(0, -2).join("/") + "/";
}

export function stripTrailingSlash(key: string) {
  return key.endsWith("/") ? key.slice(0, -1) : key;
}

export function isFolderEditable(key: string): boolean {
  return !key.split("/").includes(ASSETS_FOLDER_NAME);
}
